/**
 * SVG Helper Utilities
 * Shared functions for processing and manipulating SVG content
 */

/**
 * Process SVG content by extracting inner content and replacing colors
 * @param {string} svgString - The full SVG string
 * @param {string} color - The color to apply to the SVG (replaces #00F)
 * @returns {string} The processed SVG content
 */
export function processSvgContent(svgString, color) {
  if (!svgString) return ""

  // Extract content between <svg> and </svg> tags
  const match = svgString.match(/<svg[^>]*>([\s\S]*?)<\/svg>/i)
  let content = match ? match[1] : ""

  if (color && content) {
    content = content.replace(/fill="#00F"/gi, `fill="${color}"`)
  }

  return content
}

/**
 * Get or create SVG viewBox attribute from SVG string
 * @param {string} svgString - The full SVG string
 * @returns {string} The viewBox value
 */
export function getSvgViewBox(svgString) {
  if (!svgString) return "0 0 60 75"

  // First try to find an existing viewBox attribute
  const viewBoxMatch = svgString.match(/viewBox=["']([^"']+)["']/i)
  if (viewBoxMatch) {
    return viewBoxMatch[1]
  }

  // If no viewBox, extract width and height to create one
  const widthMatch = svgString.match(/width=["']?(\d+)["']?/i)
  const heightMatch = svgString.match(/height=["']?(\d+)["']?/i)

  const width = widthMatch ? widthMatch[1] : "60"
  const height = heightMatch ? heightMatch[1] : "75"

  return `0 0 ${width} ${height}`
}
